import { graphql } from 'gatsby';
import { Section } from '~components/Section';
import { BaseFaq } from '~components/BaseFaq';
import { Heading } from '~components/Heading';
import { applyMarker } from '~utils/applyMarker';
import { tildeToSoftHyphen } from '~utils/string';

import * as styles from './ComponentSharedCollapsibleList.module.css';

import type { ContentBlock } from '~components/types';
import type { Layout, Theme } from '~models/contentful';

export type ContentfulComponentSharedCollapsibleList = {
  __typename: 'ContentfulComponentSharedCollapsibleList';
  contentfulid: string;
  faqTitle?: string;
  listItems: { question: string; answer: { raw: string } }[];
  theme?: Theme;
  blockLayout?: Layout;
};

type ComponentSharedCollapsibleListProps = {
  content: ContentfulComponentSharedCollapsibleList;
};

export const ComponentSharedCollapsibleList: ContentBlock<ComponentSharedCollapsibleListProps> = ({
  content,
  ...sectionProps
}) => (
  <Section {...sectionProps} className={styles.section}>
    {content.faqTitle && (
      <Heading level={1} className={styles.title}>
        {applyMarker(tildeToSoftHyphen(content.faqTitle), { animated: true, markerColor: 'var(--green-50)' })}
      </Heading>
    )}
    <BaseFaq
      className={styles.faq}
      questions={content.listItems.map((content) => ({
        ...content,
        answer: content.answer.raw,
      }))}
    />
  </Section>
);

export const query = graphql`
  fragment ComponentSharedCollapsibleList on ContentfulComponentSharedCollapsibleList {
    __typename
    contentfulid
    faqTitle: title
    listItems {
      question
      answer {
        raw
      }
    }
    theme
    blockLayout
  }
`;
